<template>
  <v-container>
    <v-layout
      text-center
      wrap
    >
      <v-flex xs12>
        <v-img
          :src="require('../assets/beerstorium-logo.png')"
          class="my-3"
          contain
          lazy-src
          height="200"
        ></v-img>
      </v-flex>

      <v-card style="margin: 40px auto 0;"
      max-width="450"
      :loading="isLoading"
      class="text-center">
        <v-card-title style="margin-bottom:10px;">
          Statistiques d'affluence
        </v-card-title>
        <v-card-text v-if="statistics">
          <span class="actuel"><v-icon class="pr-4">mdi-ticket-outline</v-icon>{{ scannedOrders }} </span> | <span class="total">{{ totalOrders }}</span>
        </v-card-text>
        <hr width="350" style="margin:auto;">
        <v-card-text v-if="statistics">
          <span class="actuel"><v-icon class="pr-4">mdi-account-multiple</v-icon>{{ scannedPersons }}</span> | <span class="total">{{ totalPersons }}</span>
        </v-card-text>
      </v-card>

      <v-btn
          :elevation="24"
          fixed
          class="p-2 mx-auto pointer mega-btn"
          max-width="344"
          @click="navigate('scan')"
          fab x-large dark>
        <v-icon>mdi-qrcode</v-icon>
      </v-btn>
    </v-layout>
  </v-container>
</template>

<script>
export default {
  computed: {
    totalPersons () {
      return this.statistics.used.total_person + this.statistics.notused.total_person
    },
    scannedPersons () {
      return this.statistics.used.total_person
    },
    totalOrders () {
      return this.statistics.used.total_booking + this.statistics.notused.total_booking
    },
    scannedOrders () {
      return this.statistics.used.total_booking
    }
  },
  data () {
    return {
      isLoading: true,
      statistics: null
    }
  },
  methods: {
    navigate (value) {
      this.$router.push({ name: value })
    }
  },
  created () {
    this.$store.dispatch('fetchStatistics')
      .then(response => {
        this.statistics = response
        this.isLoading = false
      })
  }
}
</script>
<style scoped>
  .total{
    font-weight: 900;
    color: #000;
  }
  .actuel{
    font-weight: 400;
    color: #666;
  }
</style>
